import { getConfirmationEventCreator } from '../helpers/getConfirmationEventCreator';
import { getReviewEventCreator } from '../helpers/getReviewEventCreator';
import { getStartEventCreator } from '../helpers/getStartEventCreator';
import BuildVersion from '../mapBuildVersion';
import { AnalyticsEventFeatures } from '../typings/analytics';
import { getAccountStatus, getAnalyticsAllowedPaymentMethods, getAnalyticsProductType } from '../machines/helpers';
import useApiMachine from './machines/useApiMachine';
import usePaymentFlowMachine from './machines/usePaymentFlowMachine';
import useAnalyticsAutopayValues from './useAnalyticsAutopayValues';
import useAnalyticsPaymentFormValues from './useAnalyticsPaymentFormValues';
export const PAYMYBILL_CAPABILITY_STRING = 'paymybill';
function useAnalyticsEventV2Creators(feature) {
    const paymentFormValues = useAnalyticsPaymentFormValues();
    const autopayValues = useAnalyticsAutopayValues();
    const [apiMachine] = useApiMachine();
    const [paymentFlow, paymentFlowActor] = usePaymentFlowMachine();
    const { paymentResult, featureFlags } = paymentFlowActor.context;
    const { accountSummaryQueryResult, paymentEnterpriseEligibilityQueryResult } = apiMachine.context;
    const productType = getAnalyticsProductType(paymentEnterpriseEligibilityQueryResult.data, accountSummaryQueryResult.data);
    const accountStatus = getAccountStatus(accountSummaryQueryResult.data, accountSummaryQueryResult.data.product.type);
    const allowedPaymentMethods = getAnalyticsAllowedPaymentMethods(paymentEnterpriseEligibilityQueryResult.data, accountSummaryQueryResult.data, paymentFlow, featureFlags);
    const baseEvent = {
        capability: PAYMYBILL_CAPABILITY_STRING,
        feature,
        product_type: productType,
        account_status: accountStatus,
        map_version: BuildVersion.mapBuildVersion
    };
    // Cases like paylater and payoff dont have a paymentOption on their form, thats why we exclude the property. This might be changing soon.
    const paymentOption = feature === AnalyticsEventFeatures.CANCEL_AUTOPAY
        ? autopayValues.paymentOption
        : paymentFormValues.paymentOption;
    const paymentOptionObj = paymentOption
        ? { payment_option: paymentOption }
        : null;
    const createStartEventObject = getStartEventCreator(autopayValues, baseEvent, paymentFormValues, paymentOptionObj, allowedPaymentMethods);
    const createConfirmationEventObject = getConfirmationEventCreator(autopayValues, baseEvent, paymentFormValues, paymentOptionObj, paymentResult);
    const createReviewEventObject = getReviewEventCreator(baseEvent, paymentFormValues, paymentOptionObj);
    return {
        createStartEventObject,
        createConfirmationEventObject,
        createReviewEventObject
    };
}
export default useAnalyticsEventV2Creators;
